// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__fxo0Y","logo":"Navbar_logo__QPu50","svg":"Navbar_svg__uLAjl"};